import { IconLogout } from "@tabler/icons-react";
import useAuth from "../../hooks/useAuth";
import { DropdownContainer, DropdownItem } from "./components/NavDropdownUsers/DropdownItem";

const NavBarDeveloper = () => {
  const { handleLogout } = useAuth();

  return (
    <DropdownContainer>
      <DropdownItem icon={<IconLogout size={22} />} onClick={handleLogout}>
        Cerrar sesión
      </DropdownItem>
    </DropdownContainer>
  );
};

export default NavBarDeveloper;
